import React, { Component, useEffect, useState } from 'react'
import { webhookAction } from './actions';
import { Button } from 'antd';
import { WEB_HOOK_URL } from '../../request';

const Dashboard = (props) => {

  const handleMakeBuild = async () => {
    await webhookAction(); 
  };
  return (
    <div className={'asdf'} style={{ padding: 20 }}>
      <h2>Dashboard</h2>
      {WEB_HOOK_URL && (
        <Button type="primary" onClick={handleMakeBuild}>
          Make Build
        </Button>
      )}
     
    </div>
  )

}

export default Dashboard

